module.exports = __webpack_public_path__ + "img/TigerEmpire_DG.985124ac.jpg";